import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { menuAgaci, oturumKullanicisi, klasikYetkiVar } from '../yetki';
import API, { getSubeler } from '../services/api';
import './Layout.css';

// YATAY MENÜ (kullanıcı talebi: 2026-09-06). Önceki dikey kenar çubuğu ekran sayısı arttıkça
// uzuyordu; Dr.Plazma web'deki üst menü yapısına geçildi.
//
// Ana menüler ve altlarındaki ekranlar `yetki.js`'te tanımlı; kullanıcının yetkisine göre
// süzülüp buraya geliyor. İçinde görünür ekran kalmayan ana menü hiç çizilmez.
// Bir menü kaydına `grup` verilirse aynı grup ardışık listelenir ve gruplar arasına ayraç
// çizilir.
export default function Layout() {
  const [acikMenu, setAcikMenu] = useState(null);
  const navigate = useNavigate();
  const konum = useLocation();
  const menuRef = useRef(null);

  const subeKod = localStorage.getItem('subeKod');
  const subeAdi = localStorage.getItem('subeAdi') || subeKod || '';
  const kullanici = oturumKullanicisi();
  const anaMenuler = menuAgaci();

  // PORTAL GEÇİŞİ (VB6 ANA.ButtonEx10, yetki TEKN.YETK51 — 2026-09-20): şube adına tıklanınca
  // şubeler listelenir; seçilen şubeye geçilince TÜM yazılımın bağlantısı o şubeye döner.
  // Kullanıcı adı, NOO ve yetkiler giriş şubesindeki kayıttan aynen devralınır.
  const portalYetkisi = klasikYetkiVar(51);
  const [portalAcik, setPortalAcik] = useState(false);
  const [subeler, setSubeler] = useState([]);
  const [portalHata, setPortalHata] = useState('');
  const [geciliyor, setGeciliyor] = useState(false);
  const portalRef = useRef(null);

  useEffect(() => {
    if (!portalAcik) return undefined;
    setPortalHata('');
    getSubeler().then(({ data }) => setSubeler(data)).catch(() => setPortalHata('Şube listesi alınamadı.'));
    const disari = (e) => { if (portalRef.current && !portalRef.current.contains(e.target)) setPortalAcik(false); };
    const esc = (e) => { if (e.key === 'Escape') setPortalAcik(false); };
    document.addEventListener('mousedown', disari);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', disari); document.removeEventListener('keydown', esc); };
  }, [portalAcik]);

  const subeyeGec = async (s) => {
    if (s.kod === subeKod) { setPortalHata('Zaten o şubedesiniz.'); return; }
    if (!window.confirm(`${s.adi} şubesine geçiş yapmak istiyor musunuz?`)) return;
    setGeciliyor(true); setPortalHata('');
    try {
      const { data } = await API.post('/Auth/sube-degistir', { subeKod: s.kod });
      localStorage.setItem('jeton', data.jeton);
      localStorage.setItem('subeKod', data.subeKod);
      localStorage.setItem('subeAdi', data.subeAdi || data.subeKod);
      // Açık ekran yeni şubenin verisiyle baştan yüklensin.
      window.location.reload();
    } catch (err) {
      setPortalHata(err.response?.data?.hata || 'Şube geçişi yapılamadı.');
      setGeciliyor(false);
    }
  };

  // Menü dışına tıklanınca ve Esc'e basınca kapan.
  useEffect(() => {
    if (!acikMenu) return undefined;

    const disariTikla = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setAcikMenu(null);
    };
    const esc = (e) => { if (e.key === 'Escape') setAcikMenu(null); };

    document.addEventListener('mousedown', disariTikla);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', disariTikla);
      document.removeEventListener('keydown', esc);
    };
  }, [acikMenu]);

  // Sayfa değişince menü kapansın.
  useEffect(() => { setAcikMenu(null); }, [konum.pathname]);

  const cikisYap = () => {
    localStorage.removeItem('jeton');
    localStorage.removeItem('subeKod');
    localStorage.removeItem('subeAdi');
    localStorage.removeItem('kullanici');
    navigate('/login', { replace: true });
  };

  const git = (yol) => { setAcikMenu(null); navigate(yol); };

  // Aynı gruptaki maddeler arasına ayraç konmaz, grup değişince konur.
  const ayracMi = (maddeler, i) =>
    i > 0 && (maddeler[i].grup || '') !== (maddeler[i - 1].grup || '');

  return (
    <div className="uy-duzen">
      {/* Üst şerit: solda logo, ortada şube, sağda kullanıcı */}
      <header className="uy-baslik">
        {/* Dr.Plazma kurumsal logosu — lacivert zemine uygun renkli sürüm (2026-09-20). */}
        <div className="uy-marka">
          <img src={`${process.env.PUBLIC_URL}/drplazma-web-logo.png`} alt="Dr.Plazma" />
        </div>

        {portalYetkisi ? (
          <div className="uy-sube uy-portal" ref={portalRef}>
            <button className="uy-portal-dugme" onClick={() => setPortalAcik(a => !a)}
                    title="Şubeler arası geçiş (PORTAL)" aria-haspopup="true" aria-expanded={portalAcik}>
              FizyofiPlus{subeAdi ? ` · ${subeAdi}` : ''} <span className="uy-portal-ok">▾</span>
            </button>
            {portalAcik && (
              <div className="uy-portal-liste" role="menu">
                <div className="uy-portal-bas">Şubeler arası geçiş</div>
                {subeler.map(s => (
                  <button key={s.kod} role="menuitem" disabled={geciliyor}
                          className={`uy-portal-madde${s.kod === subeKod ? ' secili' : ''}`}
                          onClick={() => subeyeGec(s)}>
                    {s.kod === subeKod ? '● ' : ''}{s.adi}
                  </button>
                ))}
                {geciliyor && <div className="uy-portal-not">Geçiş yapılıyor...</div>}
                {portalHata && <div className="uy-portal-hata">{portalHata}</div>}
              </div>
            )}
          </div>
        ) : (
          <div className="uy-sube">FizyofiPlus{subeAdi ? ` · ${subeAdi}` : ''}</div>
        )}

        {/* Çıkış düğmesi buradan kaldırıldı, menünün en altına taşındı
            (kullanıcı talebi: 2026-09-06). */}
        <div className="uy-kullanici">
          <span className="uy-kullanici-ad">
            <span aria-hidden="true">👤</span> {kullanici.ad || ''}
          </span>
        </div>
      </header>

      {/* Menü şeridi */}
      <nav className="uy-menu-serit" ref={menuRef}>
        {anaMenuler.map((ana, anaIndex) => (
          <div className="uy-menu" key={ana.ad}>
            <button
              className={`uy-menu-basi${acikMenu === ana.ad ? ' acik' : ''}${ana.yetkili ? '' : ' yetkisiz'}`}
              aria-haspopup="true"
              aria-expanded={acikMenu === ana.ad}
              title={ana.yetkili ? undefined : 'Bu menüdeki ekranlar için yetkiniz yok.'}
              onClick={() => setAcikMenu(acikMenu === ana.ad ? null : ana.ad)}
            >
              {ana.ad}
            </button>

            {acikMenu === ana.ad && (
              <div className="uy-acilir" role="menu">
                {ana.maddeler.map((m, i) => (
                  <React.Fragment key={m.path}>
                    {ayracMi(ana.maddeler, i) && <div className="uy-ayrac" />}
                    {/* Yetkisiz ekran GİZLENMEZ, pasif gösterilir (kullanıcı kararı: 2026-09-21):
                        kimin neye erişebildiği değil, yazılımda neler olduğu görünsün. */}
                    <button
                      role="menuitem"
                      className={`uy-acilir-madde${konum.pathname === m.path ? ' secili' : ''}${m.yetkili ? '' : ' yetkisiz'}`}
                      disabled={!m.yetkili}
                      title={m.yetkili ? undefined : 'Bu ekran için yetkiniz yok.'}
                      onClick={() => git(m.path)}
                    >
                      <span className="uy-ikon" aria-hidden="true">{m.icon}</span>
                      {m.label}
                      {!m.yetkili && <span className="uy-kilit" aria-hidden="true">🔒</span>}
                    </button>
                  </React.Fragment>
                ))}

                {/* Çıkış YALNIZCA ilk menünün en altında, ayraçla ayrılmış: ekran değil
                    oturum işlemi, her menüde tekrarlanması anlamsız olurdu. */}
                {anaIndex === 0 && (
                  <>
                    <div className="uy-ayrac" />
                    <button role="menuitem" className="uy-acilir-madde uy-cikis-madde" onClick={cikisYap}>
                      <span className="uy-ikon" aria-hidden="true">🚪</span>
                      Çıkış
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </nav>

      <main className="uy-icerik">
        <Outlet />
      </main>
    </div>
  );
}
